/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="17.98"
        height="18.92"
        viewBox="0 0 17.98 18.92"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M4.3 9.5c.9 2.08 2.31 3.22 4.17 3.38v5.07H4.9v1h8v-1H9.45v-5.06c1.9-.14 3.33-1.28 4.25-3.4a5.73 5.73 0 0 0 3.22-2.66 8.67 8.67 0 0 0 1-3.79V2.5h-3V0H2.96v.5c0 .64 0 1.28.05 2h-3V3a8.63 8.63 0 0 0 1 3.79A5.72 5.72 0 0 0 4.3 9.5Zm10.65-6h2a7.85 7.85 0 0 1-.89 2.8 4.56 4.56 0 0 1-1.87 1.85 21.4 21.4 0 0 0 .76-4.65Zm-.9-2.51c-.07 7.32-1.7 10.88-5 10.88h-.13c-3.28 0-4.91-3.56-5-10.88Zm-11 2.51a22.31 22.31 0 0 0 .77 4.68 4.65 4.65 0 0 1-1.91-1.87 7.91 7.91 0 0 1-.89-2.8Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'TrophyIcon';

export default Icon;
